import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type { TypePostSkusParams } from '~/types/product.types';

const ENDPOINT = '/api-lip/v1/third-parties/skus';

/**
 * [상품관리][상품 등록/수정] 상품 수정 API
 */
export const fetchPutThirdPartiesSkus = async (params: TypePostSkusParams) => {
  const { data } = await axiosInstance.put<{ data: unknown }>(ENDPOINT, params);
  return data.data;
};

/**
 * [상품관리][상품 등록/수정] 상품 수정 Mutation Hook
 */
export const usePutThirdPartiesSkusMutation = () => {
  return useMutation({
    mutationFn: fetchPutThirdPartiesSkus,
  });
};
